import PropTypes from 'prop-types'

import {Map} from 'immutable'

import {TextGutterMedium} from '../../../blocks/Texts'
import {pluralize} from '../../../../../../lib/tools'

const ExistingItemPermissionInformation = ({name, ownership}) => {
  const editItemIds = ownership.get('edit-item-ids', Map())
  const editItemIdCount = editItemIds.size
  const canShareInfo = ownership.get('permission-to-add-deputy', false)

  const baseMessage = editItemIdCount ?
    `You've given ${name} permission to edit ${editItemIdCount} ${pluralize('section', editItemIdCount)} of your Everplan` :
    `Give permission to ${name} to edit sections of your Everplan on your behalf`

  const sharingMessage = editItemIdCount && canShareInfo ?
    ' and share information on your behalf from the sections they have access to.' :
    '.'

  return (
    <TextGutterMedium>
      {baseMessage}{sharingMessage}
    </TextGutterMedium>
  )
}

ExistingItemPermissionInformation.propTypes = {
  name: PropTypes.string.isRequired,
  ownership: PropTypes.instanceOf(Map).isRequired
}

export default ExistingItemPermissionInformation
